export default "__VITE_ASSET__BGY1VCoO__"